export const leerDimensionesPng = (bytes) => {
  const firma = [0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a];
  if (bytes.length < 24 || !firma.every((valor, i) => bytes[i] === valor)) return null;
  const vista = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
  return [vista.getUint32(16), vista.getUint32(20)];
};

export const leerDimensionesJpeg = (bytes) => {
  const vista = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
  if (bytes.length < 4 || vista.getUint16(0) !== 0xffd8) return null;
  let posicion = 2;
  while (posicion + 9 < bytes.length) {
    if (bytes[posicion] !== 0xff) {
      posicion += 1;
      continue;
    }
    const marcador = bytes[posicion + 1];
    const esSOF = marcador >= 0xc0 && marcador <= 0xcf && marcador !== 0xc4 && marcador !== 0xc8 && marcador !== 0xcc;
    if (esSOF) {
      return [vista.getUint16(posicion + 7), vista.getUint16(posicion + 5)];
    }
    posicion += 2 + vista.getUint16(posicion + 2);
  }
  return null;
};

export const obtenerDimensionesImagen = (bytes) => leerDimensionesPng(bytes) || leerDimensionesJpeg(bytes) || [140, 70];

export const ajustarProporcional = ([anchoOriginal, altoOriginal], [anchoMaximo, altoMaximo]) => {
  if (anchoOriginal <= 2 && altoOriginal <= 2) return [1, 1];
  const escala = Math.min(anchoMaximo / anchoOriginal, altoMaximo / altoOriginal);
  return [Math.round(anchoOriginal * escala), Math.round(altoOriginal * escala)];
};
